// extracted by mini-css-extract-plugin
module.exports = {"TDA_LEFT_BOX":"TDA_LEFT_BOX--b27GJ"};